// extracted by mini-css-extract-plugin
export var calendarSection = "CalendarSection-module--calendarSection--VGikR";